import script from "./TermsOfUse.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&setup=true&lang=js"

import "./TermsOfUse.vue?vue&type=style&index=0&id=2ee751b9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee751b9"]])

export default __exports__